import React, { useEffect, useMemo, useState } from "react";
import { Spin, message } from "antd";
import { getPaymentRecordList } from "../../api/rent-collection";
import { fmtBj } from "../../utils/bjDate";
import SettlementDrawer from "./SettlementDrawer";

const n2 = (v) =>
  v == null
    ? "-"
    : Number(v).toLocaleString("zh-CN", { maximumFractionDigits: 2 });

/**
 * 结算记录（付款记录）卡片列表：首行 日期 + 金额，次行 备注
 */
export default function PaymentRecordList({ contract }) {
  const [loading, setLoading] = useState(false);
  const [records, setRecords] = useState([]);
  const [selected, setSelected] = useState(null); // 点开的结算记录

  useEffect(() => {
    if (!contract?._id) return;
    let stale = false; // 切换合约后丢弃过期响应
    setLoading(true);
    (async () => {
      try {
        const res = await getPaymentRecordList(contract._id);
        if (!stale && res.data.code === 0) setRecords(res.data.data || []);
      } catch (e) {
        if (!stale)
          message.error(e?.response?.data?.message || "加载付款记录失败");
      } finally {
        if (!stale) setLoading(false);
      }
    })();
    return () => {
      stale = true;
    };
  }, [contract]);

  // 最近的在前
  const sorted = useMemo(
    () =>
      [...records].sort(
        (a, b) => new Date(b.paymentDate) - new Date(a.paymentDate),
      ),
    [records],
  );

  if (!sorted.length) {
    return (
      <div className="rcd-empty">{loading ? <Spin /> : "暂无付款记录"}</div>
    );
  }

  return (
    <div style={{ opacity: loading ? 0.6 : 1 }}>
      {sorted.map((r) => (
        <div
          key={r._id}
          className="rcd-bill"
          style={{ "--c": "#16a34a" }}
          role="button"
          tabIndex={0}
          onClick={() => setSelected(r)}
          onKeyDown={(e) => e.key === "Enter" && setSelected(r)}
        >
          <div className="rcd-bill-top">
            <span className="rcd-bill-room">
              {fmtBj(r.paymentDate, "YYYY/MM/DD")}
            </span>
            <span className="rcd-bill-amt" style={{ color: "#16a34a" }}>
              ¥{n2(r.paymentAmount)}
            </span>
          </div>
          {r.remark ? <div className="rcd-bill-body">{r.remark}</div> : null}
        </div>
      ))}
      <SettlementDrawer
        open={!!selected}
        record={selected}
        contract={contract}
        onCancel={() => setSelected(null)}
      />
    </div>
  );
}
